import React, { useState } from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import { LegalModal, LegalType } from './LegalModal';
import { useLang } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Footer() {
  const [legal, setLegal] = useState<LegalType | null>(null);
  const {
    t
  } = useLang();
  const links = [{
    href: '#servicios',
    label: t.footer.services
  }, {
    href: '#portafolio',
    label: t.footer.portfolio
  }, {
    href: '#nosotros',
    label: t.footer.about
  }, {
    href: '#resenas',
    label: t.footer.reviews
  }, {
    href: 'https://wa.me/447311754270?text=WEBSITE',
    label: t.footer.contact
  }];
  return <footer className="bg-dark-200 pt-16 pb-8 border-t border-white/10" data-id="element-57" data-mp="3qblyjtw9gk3p">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58" data-mp="29ydw5zakp29d">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-59" data-mp="2ey0bce9yoskt">
          <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt={t.footer.logoAlt} className="h-20 md:h-24 w-auto object-contain mb-4" data-id="element-60" data-mp="2evx8gtnpn4yo" />
          <p className="text-gold font-medium tracking-widest uppercase text-sm mb-6" data-id="element-61" data-mp="3v89f2h7oxzhx">
            {t.footer.tagline}
          </p>
          <LanguageToggle data-id="element-62" data-mp="3q7txtekag7uo" />
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12 border-y border-white/10 py-8" data-id="element-63" data-mp="830knmyxgd2l">
          {links.map(link => <a key={link.href} href={link.href} className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-64" data-mp="34p8v6p2nshq">
              {link.label}
            </a>)}
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-65" data-mp="qt8fziwdxz88">
          <div className="flex gap-4" data-id="element-66" data-mp="msg6cojlpsbf">
            <button onClick={() => setLegal('privacy')} className="hover:text-white transition-colors" data-id="element-67" data-mp="mthh0rwpgcsm">
              {t.footer.privacy}
            </button>
            <span data-id="element-68" data-mp="yupoci7z1mkd">|</span>
            <button onClick={() => setLegal('terms')} className="hover:text-white transition-colors" data-id="element-69" data-mp="yruzmehxdfl5">
              {t.footer.terms}
            </button>
          </div>

          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-70" data-mp="1clmbhtj4pbk1">
            <div className="flex items-center gap-2" data-id="element-71" data-mp="1cnoye4oziokj">
              <MessageCircle className="w-4 h-4 text-white" data-id="element-72" data-mp="1hjntsc8qd6ug" />
              <span className="text-white font-bold" data-id="element-73" data-mp="1mjsb24hgq5lq">{t.footer.whatsapp}</span>
              <a href="https://wa.me/447311754270?text=WEBSITE" className="text-gold hover:text-gold-400 transition-colors" data-id="element-74" data-mp="1mhpawrmliw3a">
                +44 7311 754270
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-75" data-mp="3t9q6g18vrit1">
              <Mail className="w-4 h-4 text-white" data-id="element-76" data-mp="3tccbnu8atm83" />
              <span className="text-white font-bold" data-id="element-77" data-mp="2afdhlagc14nq">{t.footer.email}</span>
              <a href="mailto:aselitecontractor@gmail.com" className="text-gold hover:text-gold-400 transition-colors" data-id="element-78" data-mp="25one62rgvbvo">
                aselitecontractor@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-79" data-mp="1wp0epmiasg59">
              <svg viewBox="0 0 24 24" className="w-4 h-4 text-white fill-current" aria-hidden="true" data-id="element-80" data-mp="2tdprwzizckkw">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-81" data-mp="2pa9y0ayaoybw" />
              </svg>
              <span className="text-white font-bold" data-id="element-82" data-mp="18w1r1oq0cxld">{t.footer.tiktok}</span>
              <a href="https://www.tiktok.com/@aselitecontractor" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-400 transition-colors" data-id="element-83" data-mp="13xgovjr743ua">
                @aselitecontractor
              </a>
            </div>
          </div>

          <div data-id="element-84" data-mp="2nu5n38kfd7v4">{t.footer.copyright}</div>
        </div>
      </div>

      <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-85" data-mp="2nunvt4o9xejx" />
    </footer>;
}